var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.16699 8V13.3333C3.16699 13.687 3.30747 14.0261 3.55752 14.2761C3.80756 14.5262 4.1467 14.6667 4.50033 14.6667H12.5003C12.8539 14.6667 13.1931 14.5262 13.4431 14.2761C13.6932 14.0261 13.8337 13.687 13.8337 13.3333V8",
    stroke: "#F1D87E",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50033 1.33337L7.79322 0.626267C8.18374 0.235743 8.81691 0.235743 9.20743 0.626267L8.50033 1.33337ZM9.50033 10L9.50033 11L7.50033 11L7.50033 10L9.50033 10ZM4.45989 3.9596L7.79322 0.626267L9.20743 2.04048L5.8741 5.37381L4.45989 3.9596ZM9.20743 0.626267L12.5408 3.9596L11.1266 5.37381L7.79322 2.04048L9.20743 0.626267ZM9.50033 1.33337L9.50033 10L7.50033 10L7.50033 1.33337L9.50033 1.33337Z",
    fill: "#F1D87E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShare);
export default __webpack_public_path__ + "static/media/ic_share.508da32c76a2391e02e25b4e29773303.svg";
export { ForwardRef as ReactComponent };